import { get } from "lodash";
import { useFormikContext } from "formik";
import { useEffect } from "react";

export function isValid(touched: object, errors: object, name: string) {
  return Boolean(get(touched, name)) && !get(errors, name);
}

export function isInvalid(touched: object, errors: object, name: string) {
  return Boolean(get(touched, name)) && !!get(errors, name);
}

// Formik leaf values and yup messages are strings in practice, so string is
// the default; override the generic for array/object/boolean paths
// (e.g. getValue<BeneficiaryFormValues[]>(values, "beneficiaries")).
export function getError<T = string>(
  errors: object,
  name: string
): T | undefined {
  return get(errors, name) as T | undefined;
}

export function getValue<T = string>(values: object, name: string): T {
  return get(values, name) as T;
}

export function zeroToNull(value: number | string) {
  return +value === 0 ? null : value;
}

export const getFieldErrorNames = (formikErrors: object): string[] => {
  const transformObjectToDotNotation = (
    obj: Record<string, unknown>,
    prefix = "",
    result: string[] = []
  ) => {
    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      if (!value) return;

      const nextKey = prefix ? `${prefix}.${key}` : key;
      if (typeof value === "object") {
        transformObjectToDotNotation(
          value as Record<string, unknown>,
          nextKey,
          result
        );
      } else {
        result.push(nextKey);
      }
    });

    return result;
  };

  return transformObjectToDotNotation(formikErrors as Record<string, unknown>);
};

export const ScrollToFieldError = () => {
  const { isSubmitting, isValid, errors } = useFormikContext();

  useEffect(() => {
    if (isValid) return;

    const fieldErrorNames = getFieldErrorNames(errors);

    if (fieldErrorNames.length <= 0) return;
    const element = document.querySelector<HTMLInputElement>(
      `input[name='${fieldErrorNames[0]}']`
    );
    if (!element) return;

    // Scroll to first known error into view
    element.focus();
    element.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [isSubmitting]);

  return null;
};
